module.exports = __webpack_public_path__ + "4cdd1102c2bb73ef50b968ee486fdcf7.svg";